import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCutlery } from "@fortawesome/free-solid-svg-icons";
import Calculation from "./Calculation";
import ConvertTime from "./convertTime";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { ItemRow, QuantityModal } from "./Kitchen/KitchenQuantityModal";

// ─── Card ─────────────────────────────────────────────────────────────────────
const Card = ({
    handleFinished,   // now: (itemId, quantity) => void
    handleCompleted,
    handleCancel,
    index,
    element,
    handleCookProcess,
    speakOrder,
}) => {
    const [modalItem, setModalItem] = useState(null);

    const openModal = (item) => setModalItem(item);
    const closeModal = () => setModalItem(null);

    const handleConfirm = (qty) => {
        handleFinished(modalItem.item_id, qty);
        closeModal();
    };

    const handleLongPress = (item) => {
        handleFinished(item.item_id, item.Quantity);
    };

    return (
        <div key={index}>
            {/* Quantity Modal */}
            {modalItem && (
                <QuantityModal
                    item={modalItem}
                    onClose={closeModal}
                    onConfirm={handleConfirm}
                />
            )}

            <div className="overflow-hidden bg-white rounded-lg shadow-md border border-gray-100">
                {/* Header */}
                <div
                    className={`grid grid-cols-[1fr_auto_1fr] items-center
                        bg-gradient-to-r
                        ${element.currentState === "Started"
                            ? "from-red-900 via-red-600 to-rose-500 pending-header"
                            : "from-violet-800 via-violet-700 to-purple-600"
                        }
                        text-white font-semibold px-2.5 py-2.5`}
                >
                    <div>
                        <div className="text-[10px] xl:text-sm uppercase tracking-wide">KOT ID</div>
                        <div className="text-[10px] xl:text-sm uppercase tracking-wide">{element.KOTID}</div>
                    </div>
                    <div className="text-center text-xs xl:text-sm tracking-wide uppercase">
                        {element.orderType}
                    </div>
                    <div className="flex justify-end">
                        <button
                            onClick={(e) => speakOrder(e, element.OrderItemDetailsList, element.tableNum)}
                            className="p-1.5 flex items-center justify-center rounded-full bg-white/95 shadow-md text-slate-700 border border-white/80 hover:bg-white hover:shadow-lg hover:scale-105 active:scale-95 transition-all duration-150"
                            aria-label="Read order aloud"
                            title="Read order aloud"
                        >
                            <HiOutlineSpeakerWave size={16} />
                        </button>
                    </div>
                </div>

                {/* Order Details */}
                <div className="bg-amber-50 border-b border-amber-100 px-2.5 py-2 text-center">
                    <div className="flex justify-between text-xs text-amber-800 font-medium tracking-wide">
                        <ConvertTime timeOrder={element.orderTime} />
                        <span>Guests: {element.Guest_count}</span>
                    </div>
                    <div className="text-base xl:text-lg font-bold uppercase tracking-wider text-amber-900">
                        {element.tableNum === "Take-Away" ? "Take-Away" : `Table ${element.tableNum}`}
                    </div>
                    <div className="text-[10px] xl:text-xs font-semibold tracking-wide text-amber-700 mt-0.5">{element.employee}</div>
                    <div className="mt-0.5 text-xs xl:text-sm flex justify-between items-center">
                        <div className="flex-1" />
                        <div className="flex-1 flex justify-center">
                            <Calculation Ordertime={element.orderTime} />
                        </div>
                        <div className="flex-1" />
                    </div>
                </div>

                {/* Items */}
                <div className="divide-y divide-gray-100">
                    {element.OrderItemDetailsList.map((item, idx) => (
                        <ItemRow
                            key={idx}
                            item={item}
                            onOpenModal={() => openModal(item)}
                            onLongPress={() => handleLongPress(item)}
                        />
                    ))}
                </div>

                {/* Footer */}
                <div className="p-2.5 bg-gray-50">
                    {element.currentState === "Started" ? (
                        <button
                            onClick={(e) => { e.stopPropagation(); handleCookProcess(element.table_id); }}
                            className="w-full rounded-md bg-violet-600 py-2 text-[10px] xl:text-sm text-white uppercase font-semibold tracking-widest hover:bg-violet-700 active:scale-95 active:bg-violet-800 transition-all duration-150 seen-button"
                        >
                            Mark as seen
                        </button>
                    ) : (
                        <button
                            className="w-full rounded-md flex justify-center items-center gap-2 bg-emerald-500 !py-1 xl:!py-1.5 text-sm xl:text-base text-white hover:bg-emerald-600 active:scale-95 active:bg-emerald-700 transition-all duration-150"
                            onClick={(e) => { e.stopPropagation(); handleCompleted(element.table_id); }}
                        >
                            <FontAwesomeIcon icon={faCutlery} />
                            <span className="text-xs xl:text-sm font-semibold tracking-widest uppercase">
                                Complete Order
                            </span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Card;













// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//     faCheck,
//     faTimes,
//     faMinus,
//     faCutlery,
// } from "@fortawesome/free-solid-svg-icons";
// import Calculation from "./Calculation";
// import ConvertTime from "./convertTime";
// import { HiOutlineSpeakerWave } from "react-icons/hi2";

// const Card = ({
//     handleFinished,
//     handleCompleted,
//     handleMinus,
//     handleCancel,
//     index,
//     element,
//     handleCookProcess,
//     speakOrder,
// }) => {
//     return (
//         <div key={index}>
//             <div className="overflow-hidden bg-white rounded-lg shadow-md border border-gray-100">

//                 {/* Header */}
//                 <div
//                     className={`grid grid-cols-[1fr_auto_1fr] items-center
//                         bg-gradient-to-r
//                         ${element.currentState === "Started"
//                             ? "from-red-900 via-red-600 to-rose-500 pending-header"
//                             : "from-violet-800 via-violet-700 to-purple-600"
//                         }
//                         text-white font-semibold px-2.5 py-2.5`}
//                 >
//                     <div>
//                         <div className="text-[10px] xl:text-sm uppercase tracking-wide">KOT ID</div>
//                         <div className="text-[10px] xl:text-sm uppercase tracking-wide">{element.KOTID}</div>
//                     </div>

//                     <div className="text-center text-xs xl:text-sm tracking-wide uppercase">
//                         {element.orderType}
//                     </div>

//                     <div className="flex justify-end">
//                         <button
//                             onClick={(e) => speakOrder(e, element.OrderItemDetailsList, element.tableNum)}
//                             className="
//                                 p-1.5
//                                 flex items-center justify-center
//                                 rounded-full
//                                 bg-white/95 shadow-md
//                                 text-slate-700
//                                 border border-white/80
//                                 hover:bg-white hover:shadow-lg hover:scale-105 hover:font-semibold
//                                 active:scale-95
//                                 transition-all duration-150
//                                 backdrop-blur-sm
//                             "
//                             aria-label="Read order aloud"
//                             title="Read order aloud"
//                         >
//                             <HiOutlineSpeakerWave size={16} />
//                         </button>
//                     </div>
//                 </div>

//                 {/* Order Details */}
//                 <div className="bg-amber-50 border-b border-amber-100 px-2.5 py-2 text-center">
//                     <div className="flex justify-between text-xs text-amber-800 font-medium tracking-wide">
//                         <ConvertTime timeOrder={element.orderTime} />
//                         <span>Guests: {element.Guest_count}</span>
//                     </div>

//                     <div className="text-base xl:text-lg font-bold uppercase tracking-wider text-amber-900">
//                         {element.tableNum === "Take-Away"
//                             ? "Take-Away"
//                             : `Table ${element.tableNum}`}
//                     </div>

//                     <div className="text-[10px] xl:text-xs font-semibold tracking-wide text-amber-700 mt-0.5">{element.employee}</div>

//                     <div className="mt-0.5 text-xs xl:text-sm flex justify-between items-center">
//                         {/* left spacer */}
//                         <div className="flex-1" />

//                         {/* timer — centred */}
//                         <div className="flex-1 flex justify-center">
//                             <Calculation Ordertime={element.orderTime} />
//                         </div>

//                         {/* speaker button — right */}
//                         <div className="flex-1 flex justify-end">
//                         </div>
//                     </div>
//                 </div>

//                 {/* Items */}
//                 <div className="divide-y divide-gray-100">
//                     {element.OrderItemDetailsList.map((item, idx) => (
//                         <div
//                             key={idx}
//                             className="grid grid-cols-[36px_1fr_72px] items-center px-2 py-2 font-medium text-gray-800 text-[10px] xl:text-xs"
//                         >
//                             {/* Quantity */}
//                             <div className="w-6 h-6 rounded-full bg-gray-100 text-gray-700 flex items-center justify-center font-bold">
//                                 {item.Quantity}
//                             </div>

//                             {/* Item Name + Modifications */}
//                             <div className="break-words leading-snug px-0.5 xl:!px-1">
//                                 <div>{item.ItemName}</div>
//                                 {item.Modifications && item.Modifications.trim() !== "" && (
//                                     <div className="text-[10px] xl:text-xs font-normal italic text-violet-600 mt-0.5 break-words tracking-wide">
//                                         {item.Modifications}
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Actions */}
//                             <div className="flex gap-1 xl:gap-2 justify-end">
//                                 <button
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         handleFinished(item.item_id);
//                                     }}
//                                     className="w-6 xl:w-7 h-6 xl:h-7 rounded-md bg-green-100 text-green-700 hover:bg-green-600 hover:text-white active:scale-90 active:bg-green-700 transition-all duration-150 flex items-center justify-center"
//                                     aria-label="Mark item done"
//                                 >
//                                     <FontAwesomeIcon icon={faCheck} className="text-[10px] xl:text-xs" />
//                                 </button>

//                                 {item.Quantity > 1 ? (
//                                     <button
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             handleMinus(item.item_id);
//                                         }}
//                                         className="w-6 xl:w-7 h-6 xl:h-7 rounded-md bg-amber-100 text-amber-700 hover:bg-amber-500 hover:text-white active:scale-90 active:bg-amber-700 transition-all duration-150 flex items-center justify-center"
//                                         aria-label="Decrease quantity"
//                                     >
//                                         <FontAwesomeIcon icon={faMinus} className="text-[10px] xl:text-xs" />
//                                     </button>
//                                 ) : (
//                                     <button
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             handleCancel(item.item_id);
//                                         }}
//                                         className="w-6 xl:w-7 h-6 xl:h-7 rounded-md bg-red-100 text-red-600 hover:bg-red-600 hover:text-white active:scale-90 active:bg-red-700 transition-all duration-150 flex items-center justify-center"
//                                         aria-label="Cancel item"
//                                     >
//                                         <FontAwesomeIcon icon={faTimes} className="text-[10px] xl:text-xs" />
//                                     </button>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Footer */}
//                 <div className="p-2.5 bg-gray-50">
//                     {element.currentState === "Started" ? (
//                         <button
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleCookProcess(element.table_id);
//                             }}
//                             className="
//                                 w-full rounded-md
//                                 bg-violet-600
//                                 py-2 text-[10px] xl:text-sm text-white uppercase
//                                 font-semibold tracking-widest
//                                 hover:bg-violet-700
//                                 active:scale-95 active:bg-violet-800
//                                 transition-all duration-150
//                                 seen-button
//                             "
//                         >
//                             Mark as seen
//                         </button>
//                     ) : (
//                         <button
//                             className="w-full rounded-md flex justify-center items-center gap-2 bg-emerald-500 !py-1 xl:!py-1.5 text-sm xl:text-base text-white hover:bg-emerald-600 active:scale-95 active:bg-emerald-700 transition-all duration-150"
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleCompleted(element.table_id);
//                             }}
//                         >
//                             <FontAwesomeIcon icon={faCutlery} />
//                             <span className="text-xs xl:text-sm font-semibold tracking-widest uppercase">
//                                 Complete Order
//                             </span>
//                         </button>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Card;

















// import React from 'react'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCheck, faTimes, faMinus, faCutlery, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
// import Calculation from './Calculation';
// import ConvertTime from './convertTime';
// import { useNavigate } from 'react-router-dom';


// const Card = ({ handleFinished, handleCompleted, handleMinus, handleCancel, index, element, type, handleCookProcess }) => {
//     const navigate = useNavigate();

//     if (type === 'kitchen') {
//         return (
//             <div className="w-[300px]" key={index}>
//                 <div className='ticket'>
//                     <div className='item-order-type'>
//                         <div className='kot-id'>
//                             <p>KOT ID: <span>{element.KOTID}</span></p>
//                         </div>
//                         <p className='item-type'>{element.orderType}</p>
//                         <div className='top-icon'>
//                             <FontAwesomeIcon
//                                 icon={faCheckCircle}
//                                 className="check-icon"
//                                 onClick={() => handleCompleted(element.table_id)}
//                             />
//                         </div>
//                     </div>
//                     <div className='item-course-detail'>
//                         <div className='item-detail'>
//                             <div className='time-guests'>
//                                 <ConvertTime timeOrder={element.orderTime} />
//                                 <span>
//                                     Guests: {element.Guest_count}
//                                 </span>
//                             </div>
//                             <div className='table-num'>Table No: {element.tableNum === "Take-Away" ? "" : element.tableNum}</div>
//                             <span>{element.employee}</span>
//                             <div className='time-order'>
//                                 <Calculation Ordertime={element.orderTime} />
//                             </div>
//                         </div>
//                         {element.OrderItemDetailsList.map((item, index) => (
//                             <div className='course-item' key={index}>
//                                 <table className="item-table">
//                                     <tbody>
//                                         <tr key={item.item_id} className='item-body-table'>
//                                             <td className="quantity-box">{item.Quantity}</td>
//                                             <td className="food">{item.ItemName}</td>
//                                             <td >
//                                                 <div className="item-check-process">
//                                                     <FontAwesomeIcon icon={faCheck} className="completed-icon" onClick={() => handleFinished(item.item_id)} />
//                                                     {item.Quantity > 1 ? (
//                                                         <FontAwesomeIcon icon={faMinus} className="minus-icon" onClick={() => handleMinus(item.item_id)} />
//                                                     ) : (
//                                                         <FontAwesomeIcon icon={faTimes} className="delete-icon" onClick={() => handleCancel(item.item_id)} />
//                                                     )}
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ))}
//                         <div className='seen-div'>
//                             {(element.currentState === "Started") ?
//                                 <button className='seen-btn' onClick={() => handleCookProcess(element.table_id)}>
//                                     SEEN
//                                 </button>
//                                 :
//                                 <button className='start-cooking'>
//                                     <FontAwesomeIcon icon={faCutlery} />
//                                 </button>
//                             }
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     if (type) {
//         return (
//             <div className="w-[300px]" key={index}>
//                 <div className='ticket'>
//                     <div className='item-order-type'>
//                         <div className='kot-id'>
//                             <p>KOT ID: <span>{element.KOTID}</span></p>
//                         </div>
//                         <p className='item-type'>{element.orderType}</p>
//                         <div className='top-icon'>
//                             <FontAwesomeIcon
//                                 icon={faCheckCircle}
//                                 className="check-icon"
//                             />
//                         </div>
//                     </div>
//                     <div className='item-course-detail'>
//                         <div className='item-detail'>
//                             <div className='time-guests'>
//                                 <ConvertTime timeOrder={element.orderTime} />
//                                 <span>
//                                     Guests: {element.Guest_count}
//                                 </span>
//                             </div>
//                             <div className='table-num'>Table No: {element.tableNum === "Take-Away" ? "" : element.tableNum}</div>
//                             <span>{element.employee}</span>
//                             <div className='time-order'>
//                                 <Calculation Ordertime={element.orderTime} />
//                             </div>
//                         </div>
//                         {element.OrderItemDetailsList.map((item, index) => (
//                             <div className='course-item' key={index}>
//                                 <table className="item-table">
//                                     <tbody>
//                                         <tr key={item.item_id} className='item-body-table'>
//                                             <td className="quantity-box">{item.Quantity}</td>
//                                             <td className="food">{item.ItemName}</td>
//                                             <td>
//                                                 <div className="item-check-process">
//                                                     <FontAwesomeIcon icon={faCheck} className="completed-icon" />
//                                                     {item.Quantity > 1 ? (
//                                                         <FontAwesomeIcon icon={faMinus} className="minus-icon" />
//                                                     ) : (
//                                                         <FontAwesomeIcon icon={faTimes} className="delete-icon" />
//                                                     )}
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     if (!type) {
//         navigate('/')
//     }
// }

// export default Card;
